import { createContext, memo, useContext, useEffect } from 'react';
import { useListPresentationData } from './useListPresentationData';
import ListPresentationWrapper from '../ListPresentationWrapper';
import { useWidgetDndContextData } from 'src/context/WidgetDndContext';

const LIST_PRESENTATION_INITIAL_DATA = {
  state: {
    listPresentationConfig: {} as any,
    cardFrameConfig: {} as any,
    isMobile: false,
    moreItemsAvailable: false,
    itemCountTotal: 0,
    contentTypeConditions: {} as any,
    iterableList: [] as any[],
    featuredReelConfigs: {} as any,
    isLayoutCarousel: false,
  },
  refSetters: {} as Record<string, any>,
  refs: {} as Record<string, any>,
  utilities: {
    getConfigsAndUtils: () => {
      return {
        generalValues: {} as any,
        setters: {
          setViewAllItemsConfig: (() => {}) as any,
          setCarouselIndicatorConfigs: (() => {}) as any,
        },
      };
    },
  },
  props: {} as any,
  elementsToMap: {
    header: [] as Array<{ Component: any; props: any }>,
    body: [] as Array<{ Component: any; props: any }>,
    footer: [] as Array<{ Component: any; props: any }>,
  },
} as const;

type TypeContextData = typeof LIST_PRESENTATION_INITIAL_DATA;

export const ListPresentationContextCreator = createContext<TypeContextData>(
  LIST_PRESENTATION_INITIAL_DATA
);

export const ListPresentationContext = memo(function ListPresentationCtxComponent(props) {
  const data = useListPresentationData();
  const {
    widgetContextState: { isBuilder },
  } = useWidgetDndContextData();
  // const isBuilderRoute = window.location.pathname.includes(PATH.WEBSITE_BUILDER);

  if (!isBuilder) data.internalData.utilities.setProps(props);

  useEffect(() => {
    if (isBuilder) data.internalData.utilities.setProps(props);
  }, [props, isBuilder]);

  return (
    <ListPresentationContextCreator.Provider value={data.externalData as any}>
      <ListPresentationWrapper />
    </ListPresentationContextCreator.Provider>
  );
});

export const useListPresentationContextData = () => {
  const data = useContext(ListPresentationContextCreator);
  return data;
};
